module.exports = __webpack_public_path__ + "static/media/tier-9.2c376877.jpg";